import React from "react";
import { useTranslation } from "react-i18next";
import { tours } from "../data/Tours";
import Navbar from "./Navbar";
import Footer from "./Footer";

// Učitaj ažurirane podatke
const getTours = () => {
  const saved = localStorage.getItem("travelina_tours");
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch (e) {
      return tours;
    }
  }
  return tours;
};

const TOUR_TITLES = {
  valladolid: {
    hr: "Valladolid",
    en: "Valladolid",
    de: "Valladolid",
    es: "Valladolid",
  },
  alicante: {
    hr: "Alicante",
    en: "Alicante",
    de: "Alicante",
    es: "Alicante",
  },
};

const TOUR_DESCRIPTIONS = {
  valladolid: {
    hr: "Otkrijte španjolski grad bogat poviješću i kulturom.",
    en: "Discover a Spanish city rich in history and culture.",
    de: "Entdecken Sie eine spanische Stadt voller Geschichte und Kultur.",
    es: "Descubre una ciudad española rica en historia y cultura.",
  },
  alicante: {
    hr: "Uživajte u sunčanoj obali i bogatoj kulturi.",
    en: "Enjoy the sunny coast and rich culture.",
    de: "Genießen Sie die sonnige Küste und reiche Kultur.",
    es: "Disfruta de la costa soleada y la rica cultura.",
  },
};

function formatDate(dateStr, lng) {
  const date = new Date(dateStr);
  return date.toLocaleDateString(lng || "hr-HR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

export default function Blog() {
  const { t, i18n } = useTranslation();
  const lng = i18n.language || "hr";
  const base = lng.slice(0, 2);
  const currentTours = getTours();

  return (
    <div className="app">
      <Navbar />
      <main>
        <section className="section" style={{ paddingTop: "6rem" }}>
          <div className="container">
            <header className="section-header">
              <h1>{t("blog.pageTitle")}</h1>
              <p>{t("blog.pageSubtitle")}</p>
            </header>

            <div className="blog-grid">
              {currentTours.map((tour) => {
                const title =
                  TOUR_TITLES[tour.key][base] || TOUR_TITLES[tour.key].en;
                const desc =
                  TOUR_DESCRIPTIONS[tour.key][base] ||
                  TOUR_DESCRIPTIONS[tour.key].en;
                return (
                  <article className="blog-card" key={tour.id}>
                    <div
                      className="blog-image"
                      style={{ backgroundImage: `url(${tour.image})` }}
                    >
                      <div className="blog-tag">{tour.tag}</div>
                    </div>
                    <div className="blog-body">
                      <h2>{title}</h2>
                      <div className="blog-meta">
                        <span>📍 {tour.country}</span>
                        <span>🗓 {formatDate(tour.date, lng)}</span>
                        <span>
                          ⏳ {tour.days} {t("blog.days")} / {tour.nights}{" "}
                          {t("tours.nights")}
                        </span>
                      </div>
                      <p className="blog-description">{desc}</p>
                      {tour.blogText && tour.blogText[base] && (
                        <div
                          className="blog-full-text"
                          style={{
                            marginTop: "1rem",
                            padding: "1rem",
                            background: "rgba(2, 6, 23, 0.5)",
                            borderRadius: "0.5rem",
                            fontSize: "0.95rem",
                            lineHeight: "1.7",
                            color: "#d1d5db",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {tour.blogText[base]}
                        </div>
                      )}
                      <div className="blog-footer">
                        <div className="blog-price">
                          <span className="blog-price-main">
                            {t("tours.from")} {tour.price} €
                          </span>
                          <span className="blog-price-note">
                            {t("tours.perPerson")}
                          </span>
                        </div>
                        <button className="btn ghost">
                          {t("blog.btnReadMore")}
                        </button>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

